/* --------------------------------------------------------------------- 
AjaxContentPagination widget.
  Handles paging for content areas that utilize AbstractContentList and
  the AbstractContentPaginationWidget.

[Required Parameters]
    NavigationUrl               required.
        The url the be called for all pager data requests.
        This will be a post request and may have parameters (see 
        RequestDataFunc for details).

    OnChange                    required.
        Callback with a signature in the format: 
            function(mode)
        This is called before the call to the server for the new page 
        data.

    OnSuccess                   required.
        Callback with a signature in the format: 
            function(mode, aData, aTextStatus, aJqXHR)
        This is called upon a successful call to the server for the new 
        page data.  It is called before the pager is updated and before 
        any one-time callbacks are called as well.

    OnError                     required.
        Callback with a signature in the format: 
            function(mode, aJqXHR, aTextStatus, aErrorThrown)
        This is called upon an unsuccessful call to the server for the 
        new page data.  It is called before the pager is updated and 
        before any one-time callbacks are called as well.

[Optional Parameters]
    InitialPagerData            default: null
        Data supplied to initialize the pager to match any data that 
        might appear initially.

    RequestDataFunc             default: null
        A function with the signature in the format:
            function(isNewSearch, isReset)
        This is called before calls to the NavigationUrl to retrieve 
        desired parameters for the pager call.  For instance, the 
        current search filters.

    ActionCallbacks             default: null
        A set of callbacks to be called upon pager action call (First, 
        Previous, Next, Last).

    LiveRegionId                default: null
        The id attribute of the element containing the paged content, 
        for ARIA labelling.

[Classes for important elements - may not be null or empty.]
    WrapperClass                default: 'fbcms_ajcp'
    ButtonClass                 default: 'ajcp_button'
    PagesWrapperClass           default: 'ajcp_pages'
    PageButtonClass             default: 'page_button'
    FeedButtonClass             default: 'feed_button'
    PageActionFirstButtonClass  default: 'ajcp_first'
    PageActionPrevButtonClass   default: 'ajcp_prev'
    PageActionNextButtonClass   default: 'ajcp_next'
    PageActionLastButtonClass   default: 'ajcp_last'
    PageActionNumButtonClass    default: 'ajcp_page'
    FeedActionMoreButtonClass   default: 'ajcp_feedmore'
    ActiveButtonClass           default: 'ajcp_active'
    DisableButtonClass          default: 'disable_button

   --------------------------------------------------------------------- */

const AjaxContentPaginationModes = Object.freeze({
    off: "Off",
    feedstyle: "FeedStyle",
    loadmorestyle: "LoadMoreStyle"
});

(function ($)
{
    const DataAttrNames = Object.freeze({
        page: 'ajcp-page',
        total: 'ajcp-totalpages',
        current: 'ajcp-currentpage',
        action: 'ajcp-action',
        mode: 'ajcp-mode'
    });


    $.widget("ui.AjaxContentPagination",
    {
        options:
        {
            NormalContainer: null,
            MoreContainer: null,
            NavigationUrl: null,
            OnChange: null,
            OnSuccess: null,
            OnError: null,
            OnComplete: null,
            InitialPagerData: null,
            RequestDataFunc: null,
            ActionCallbacks: null,
            LiveRegionId: null,
            WrapperClass: 'fbcms_ajcp',
            ButtonClass: 'ajcp_button',
            PagesWrapperClass: 'ajcp_pages',
            PageButtonClass: 'page_button',
            FeedButtonClass: 'feed_button',
            PageActionFirstButtonClass: 'ajcp_first',
            PageActionPrevButtonClass: 'ajcp_prev',
            PageActionNextButtonClass: 'ajcp_next',
            PageActionLastButtonClass: 'ajcp_last',
            PageActionNumButtonClass: 'ajcp_page',
            FeedActionMoreButtonClass: 'ajcp_feedmore',
            ActiveButtonClass: 'ajcp_active',
            DisableButtonClass: 'disable_button',
            LoadingTitle: "Content"
        },

        _getLoadingContent: function()
        {
            return `<div class="ajcp_loading_message">
                <img src="/img/spacer.gif" alt="Loading ${this.options.LoadingTitle}..." title="Loading ${this.options.LoadingTitle}..."/>
                <div>Loading...</div>
             </div>`;
        },

        _getErrorHtml: function ()
        {
            return `<div>
            <img src="/img/spacer.gif" alt="Error Loading ${this.options.LoadingTitle}." title="Error Loading ${this.options.LoadingTitle}."/>
            <div>Error Loading ${this.options.LoadingTitle}.</div>
            </div>`;
        },

        _destroy: function ()
        {
        },

        _init: function ()
        {
        },

        _create: function ()
        {
            const self = this;
            const jElement = $(self.element);

            if (self.options.NavigationUrl === null
                || self.options.NormalContainer === null
                || self.options.MoreContainer === null
                || FBUtilities.IsParameterUndefinedOrNull(self.options.WrapperClass)
                || FBUtilities.IsParameterUndefinedOrNull(self.options.ButtonClass)
                || FBUtilities.IsParameterUndefinedOrNull(self.options.PagesWrapperClass)
                || FBUtilities.IsParameterUndefinedOrNull(self.options.PageButtonClass)
                || FBUtilities.IsParameterUndefinedOrNull(self.options.FeedButtonClass)
                || FBUtilities.IsParameterUndefinedOrNull(self.options.PageActionFirstButtonClass)
                || FBUtilities.IsParameterUndefinedOrNull(self.options.PageActionPrevButtonClass)
                || FBUtilities.IsParameterUndefinedOrNull(self.options.PageActionNextButtonClass)
                || FBUtilities.IsParameterUndefinedOrNull(self.options.PageActionLastButtonClass)
                || FBUtilities.IsParameterUndefinedOrNull(self.options.PageActionNumButtonClass)
                || FBUtilities.IsParameterUndefinedOrNull(self.options.FeedActionMoreButtonClass)
                || FBUtilities.IsParameterUndefinedOrNull(self.options.ActiveButtonClass)
                || FBUtilities.IsParameterUndefinedOrNull(self.options.DisableButtonClass))
            {
                return;
            }

            // if initial pager data has been provided, set the markup.
            if (self.options.InitialPagerData !== null)
            {
                self._updatePagerMarkup(self.options.InitialPagerData);
            }

            self._updateButtons(null);
            
            // buttons click event handler
            jElement.on(
                'click',
                '.' + self.options.ButtonClass,
                function(aEvent)
                {
                    const lButton = $(aEvent.target).closest('.' + self.options.ButtonClass);
                    // if no button is found, drop.
                    if (lButton.length === 0 || lButton.hasClass(self.options.DisableButtonClass))
                    {
                        return false;
                    }

                    const page = lButton.data(DataAttrNames.page);
                    const action = lButton.data(DataAttrNames.action);
                    
                    if (!FBUtilities.IsParameterUndefinedOrNull(page))
                    {
                        // if the button has a target page number, call to change page.
                        self.ChangePage(page);
                    }
                   
                    if (!FBUtilities.IsParameterUndefinedOrNull(action))
                    {
                        // if a special action button has been pressed, perform the action.
                        self.PerformAction(action);
                    }

                    return false;
                }
            );

            // set an ARIA attribute to indicate what the buttons control.
            if (!FBUtilities.IsParameterUndefinedOrNull(self.options.LiveRegionId))
            {
                jElement.find('.' + self.options.ButtonClass).attr('aria-controls', self.options.LiveRegionId);
            }
        },

        // Update the pager markup given the new pager data.
        _updatePagerMarkup: function(aPagerData)
        {
            const self = this;
            const jElement = $(self.element);
            const lTotalPages = Number(aPagerData['total_pages']);
            const lCurrentPage = Number(aPagerData['current_page']);
            const lFirstPage = Number(aPagerData['pager_first_page']);
            const lLastPage = Number(aPagerData['pager_last_page']);
            const lPaginationContainer = jElement.find('.' + self.options.WrapperClass);

            // drop out if the container can't be found.
            if (lPaginationContainer.length === 0)
            {
                return;
            }

            lPaginationContainer.data(DataAttrNames.total, lTotalPages);
            lPaginationContainer.data(DataAttrNames.current, lCurrentPage);

            // drop out if the page numeral buttons container can't be found.
            const lPagesContainer = lPaginationContainer.find('.' + self.options.PagesWrapperClass);
            if (lPagesContainer.length === 0)
            {
                return;
            }

            // clear the container and the data attributes attached to it.
            lPagesContainer.html('');

            // hide the container if there is no data.
            // show it if there is any kind of data.
            if (aPagerData === null)
            {
                lPaginationContainer.hide();
                return;
            }
            else
            {
                lPaginationContainer.show();
            }

            // hide the container if there is only one page.
            if (lTotalPages <= 1)
            {
                lPaginationContainer.find('.' + self.options.PageButtonClass).hide();
                lPagesContainer.hide();
            }

            // prepare an ARIA attribute to indicate what the buttons control.
            let lAriaControls = '';
            if (!FBUtilities.IsParameterUndefinedOrNull(self.options.LiveRegionId))
            {
                lAriaControls = ` aria-controls="${self.options.LiveRegionId}"`;
            }

            // build the new html for the page numeral buttons container.
            let lNewHtml = '';
            for (let lIndex = lFirstPage; lIndex <= lLastPage; lIndex += 1)
            {
                lNewHtml += `<a href="#" class="${self.options.ButtonClass} ${self.options.PageButtonClass}" data-${DataAttrNames.page}="${lIndex}"${lAriaControls}> <span class="screen-reader-text">Page</span> ${lIndex} </a >\n`;
            }//endfor
            lPaginationContainer.children('.' + self.options.ButtonClass + '.' + self.options.PageActionLastButtonClass).data(DataAttrNames.page, lTotalPages);

            // set the container html and the data attributes attached to it.
            lPagesContainer.html(lNewHtml);
        },

        ResetForm: function ()
        {
            this.ChangePage(1, true, true);
        },

        SubmitForm: function ()
        {
            this.ChangePage(1, true, false);
        },
        
        ///////////////////////////////////////////////////////////////////////////////
        /// ChangePage: function (aPageNumber)
        /// aPageNumber - the desired page number. If null, or invalid, 1 will be used.
        /// aIsNewSearch - (optional) Set to true to indicate that this a new search. This value is simply passed into the RequestDataFunc callback function.
        /// aIsReset - (optional) Set to true to indicate that this form reset. This value is simply passed into the RequestDataFunc callback function.
        ChangePage: function (aPageNumber, aIsNewSearch, aIsReset)
        {
            const self = this;
            const mode = $(self.element).find('.' + self.options.WrapperClass).data(DataAttrNames.mode);            
            const container = AjaxContentPaginationModes.loadmorestyle === mode ? self.options.MoreContainer : self.options.NormalContainer;
            const loadingHtml = self._getLoadingContent();

            if (AjaxContentPaginationModes.loadmorestyle === mode)
            {
                // TODO: DO THIS NICELY SO IT CAN BE REPLACE WITH THE ACTUAL RESULTS.
                container.append(loadingHtml);
            }
            else
            {
                container.html(loadingHtml);
            }

            // call the OnChange callback.
            if (typeof self.options.OnChange === 'function')
            {
                self.options.OnChange(mode);
            }

            // parse the page number and build the data.
            const lPageNumber = $.isNumeric(aPageNumber) ? aPageNumber : 1;
            let requestData = {
                'NavCurrentPageNumber': lPageNumber,
                'NavButtonClicked': "None",
                'rndm': Math.random(),
                'ajcpmode': mode
            };

            // if a RequestDataFunc has been provided, call it and add the provided data.
            if (self.options.RequestDataFunc !== null)
            {
                const isNewSearch = aIsNewSearch === undefined ? false : aIsNewSearch;
                const isReset = aIsReset === undefined ? false : aIsReset;

                const lFuncData = self.options.RequestDataFunc(isNewSearch, isReset);
                requestData = $.extend( requestData, lFuncData );
            }

            // make the ajax call.
            $.ajax(self.options.NavigationUrl, 
            {                
                data: requestData,
                type: 'POST',
                success: function (aData, aTextStatus, aJqXHR)
                {
                    if (AjaxContentPaginationModes.loadmorestyle === mode)
                    {
                        container.find('.ajcp_loading_message').remove();
                        container.append(aData);
                    }
                    else
                    {
                        container.html(aData);
                    }

                    if (typeof self.options.OnSuccess === 'function')
                    {
                        self.options.OnSuccess(mode, aData, aTextStatus, aJqXHR);
                    }

                    // retrieve & format the pager data.
                    const lPagerData = aJqXHR.getResponseHeader('pager_data');
                    const lPagerObject = eval("(" + lPagerData + ")");

                    // update the pager
                    self._updatePagerMarkup(lPagerObject);
                    self._updateButtons(aPageNumber);
                },
                error: function (aJqXHR, aTextStatus, aErrorThrown)
                {
                    const errorHtml = self._getErrorHtml();
                    if (AjaxContentPaginationModes.loadmorestyle === mode)
                    {
                        container.append(errorHtml);
                    }
                    else
                    {
                        container.html(errorHtml);
                    }

                    if (typeof self.options.OnError === 'function')
                    {
                        self.options.OnError(mode, aJqXHR, aTextStatus, aErrorThrown);
                    }
                },
                complete: function (aJqXHR, aTextStatus)
                {
                    if (typeof self.options.OnComplete === 'function')
                    {
                        self.options.OnComplete(mode);
                    }
                }
            });
        },

        ///////////////////////////////////////////////////////////////////////////////
        /// PerformAction: function (aLoopOnEnd, aCallbacks)
        /// aAction - the action to call from the ActionCallbacks callback set.
        PerformAction: function(aAction)
        {
            const self = this;
            FBUtilities.RunCallback(self.options.ActionCallbacks, aAction);
        },

        ///////////////////////////////////////////////////////////////////////////////
        /// NextPage: function (aLoopOnEnd, aCallbacks)
        /// aLoopOnEnd - true to loop back to the first page if we're already on the 
        ///     last page.
        /// aCallbacks - a set of one-time callbacks for this call (optional).
        NextPage: function (aLoopOnEnd)
        {
            this._stepPage(true, aLoopOnEnd);
        },

        ///////////////////////////////////////////////////////////////////////////////
        /// PrevPage: function (aLoopOnEnd)
        /// aLoopOnEnd - true to loop back to the last page if we're already on the 
        ///     first page.
        PrevPage: function (aLoopOnEnd)
        {
            this._stepPage(false, aLoopOnEnd);
        },

        // worker for page incrementation.
        _stepPage: function (aForward, aLoopOnEnd)
        {
            const self = this;
            const jElement = $(self.element);

            // if the pager container can't be found, drop.
            var lPaginationContainer = jElement.find('.' + self.options.WrapperClass);
            if (lPaginationContainer.length === 0)
            {
                return;
            }

            // retrieve and check total pages and current page.
            // if either is null, drop.
            const lTotalPages = FBUtilities.GetIntOrNull(lPaginationContainer.data(DataAttrNames.total));
            const lCurrentPage = FBUtilities.GetIntOrNull(lPaginationContainer.data(DataAttrNames.current));
            
            if (lTotalPages === null
                || lCurrentPage === null)
            {
                return;
            }

            // calculate the new page number.
            let lNewPage = null;
            if (aForward)
            {
                // if counting "forward" or up...
                if (lCurrentPage === lTotalPages)
                {
                    // if we're looping go to the first, or null is fine if not.
                    if (aLoopOnEnd === false)
                    {
                        return;
                    }
                    lNewPage = 1;
                }
                else
                {
                    lNewPage = lCurrentPage + 1;
                }
            }
            else
            {
                // if counting "backward" or down...
                if (lCurrentPage === 1)
                {
                    // if we're looping go to the last, or null is fine if not.
                    if (aLoopOnEnd === false)
                    {
                        return;
                    }
                    lNewPage = lTotalPages;
                }
                else
                {
                    lNewPage = lCurrentPage - 1;
                }
            }
            self.ChangePage(lNewPage);
        },

        // worker that updates all the buttons.
        _updateButtons: function(aCurrentPage)
        {
            const self = this;
            const jElement = $(self.element);

            // if the pager container can't be found, drop.
            const lPaginationContainer = jElement.find('.' + self.options.WrapperClass);
            if (lPaginationContainer.length === 0)
            {
                return;
            }

            // the page numeral container
            const lPagesContainer = lPaginationContainer.find('.' + self.options.PagesWrapperClass);

            // load the total pages and current page.
            // if current page sent in is null, retrieve the from the data attribute,
            // if it is not, set the data attribute to match.
            const lTotalPages = lPaginationContainer.data(DataAttrNames.total);
            let lCurrentPage = aCurrentPage;
            if (lCurrentPage === null)
            {
                lCurrentPage = lPaginationContainer.data(DataAttrNames.current);
            }
            else
            {
                lPaginationContainer.data(DataAttrNames.current, lCurrentPage);
            }

            // the page buttons
            const lPaginationButtons = jElement.find('.' + self.options.ButtonClass);

            // the pager should only show if there is more than one page.
            if (Number(lTotalPages) <= 1)
            {
                lPaginationContainer.find('.' + self.options.PageButtonClass).hide();
                if (lPagesContainer.length > 0)
                {
                    lPagesContainer.hide();
                }
            }
            else
            {
                lPaginationContainer.find('.' + self.options.PageButtonClass).show();
                if (lPagesContainer.length > 0)
                {
                    lPagesContainer.show();
                }
            }

            // retrieve the previous and next buttons.
            const lPrevButton = jElement.find('.' + self.options.PageActionPrevButtonClass);
            const lNextButton = jElement.find('.' + self.options.PageActionNextButtonClass);
            const lMoreButton = jElement.find('.' + self.options.FeedActionMoreButtonClass);
            // set ther data attributes.
            if (lPrevButton.length !== 0)
            {
                lPrevButton.data(DataAttrNames.page, lCurrentPage - 1);
            }
            if (lNextButton.length !== 0)
            {
                lNextButton.data(DataAttrNames.page, lCurrentPage + 1);
            }
            if (lMoreButton.length !== 0)
            {
                lMoreButton.data(DataAttrNames.page, lCurrentPage + 1);
            }

            if (Number(lTotalPages) == Number(lCurrentPage))
            {
                lMoreButton.hide();
            }

            if (lPaginationButtons.length > 0)
            {
                // remove all disable and active class values from the buttons.
                lPaginationButtons.removeClass(self.options.DisableButtonClass);
                lPaginationButtons.removeClass(self.options.ActiveButtonClass);

                // loop through the buttons and set the new active and disabled settings.
                $.each(
                    lPaginationButtons,
                    function (aIndex, aValue)
                    {
                        const jValue = $(aValue);

                        const lTargetPage = jValue.data(DataAttrNames.page);

                        if (lTargetPage < 1
                            || lTargetPage > lTotalPages
                            || lTargetPage === lCurrentPage)
                        {
                            jValue.addClass(self.options.DisableButtonClass);
                        }
                        if (lTargetPage === lCurrentPage)
                        {
                            jValue.addClass(self.options.ActiveButtonClass);
                        }
                    }
                );
            }
        }
        
    });
})(jQuery);
